import { render } from "./BrandsLogos.vue?vue&type=template&id=e00d1c12&scoped=true"
import script from "./BrandsLogos.vue?vue&type=script&lang=js"
export * from "./BrandsLogos.vue?vue&type=script&lang=js"

import "./BrandsLogos.vue?vue&type=style&index=0&id=e00d1c12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00d1c12"]])

export default __exports__